import React from "react";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getText } from "../libs/utils";

export default function CClipboard(props) {

  const showMessage = () => {
    window.showMessage(getText("copied"));
  };

  return <CopyToClipboard text={props.text} onCopy={showMessage}>
    {props.children}
  </CopyToClipboard>

}